'use client'

import usePostTrialApplyStepViewedEvent from '@components/hooks/usePostTrialApplyStepViewedEvent'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import type { ApplySuccessPageProps } from 'app/p/apply-success/[token]/[step]/page'
import { WarmTransferIntro } from './WarmTransfer/WarmTransferIntro'

export function WarmTransferStep({
  idToken,
}: Pick<ApplySuccessPageProps, 'idToken'>) {
  usePostTrialApplyStepViewedEvent({
    trialApplicationIdToken: idToken,
    type: 'warm-transfer',
  })

  const handleStartCall = () => {
    trackEvent(TrackingEvents.WARM_TRANSFER_START_BUTTON_CLICKED, {
      trialApplicationIdToken: idToken,
    })
  }

  return <WarmTransferIntro idToken={idToken} onStartCall={handleStartCall} />
}
